import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import $i18n from 'panda-i18n';
import { CnButton, CnIcon } from '@alife/cn-ui';
function useVersionSwitch(onSwitchVersion, isHiddenHelpDoc, option) {
    const [versionLocal, setVersionLocal] = useState('oneSearch');
    const version = useMemo(() => {
        if (typeof option?.version !== 'undefined') {
            return option?.version;
        }
        return versionLocal;
    }, [versionLocal, option]);
    const setVersion = useMemo(() => {
        if (option?.setVersion) {
            return option?.setVersion;
        }
        return setVersionLocal;
    }, [setVersionLocal, option]);
    const isOneSearchVersion = version === 'oneSearch';
    const changeSearchModeBtn = (_jsxs(CnButton, { type: isOneSearchVersion ? 'secondary' : 'normal', onClick: () => {
            setVersion(isOneSearchVersion ? 'normal' : 'oneSearch');
            typeof onSwitchVersion === 'function' &&
                onSwitchVersion(!isOneSearchVersion);
        }, "data-hottag": `cn.component.one-search.${isOneSearchVersion ? 'useFilter' : 'useOneSearch'}`, "data-hottag-name": isOneSearchVersion ? '切换为传统版' : '切换为敏捷版', "data-hottag-ext-params": JSON.stringify({
            sampling: 1,
        }), children: [_jsx(CnIcon, { type: 'filter', size: 'medium' }), isOneSearchVersion
                ? $i18n.get({
                    id: 'SwitchToTraditionalVersion',
                    dm: '切换为传统版',
                })
                : $i18n.get({ id: 'SwitchToAgileVersion', dm: '切换为敏捷版' })] }, 'switchVersion'));
    return {
        isOneSearchVersion,
        setSearchVersion: setVersion,
        extendButtons: isHiddenHelpDoc
            ? [changeSearchModeBtn]
            : [
                _jsxs(CnButton, { text: true, component: 'a', href: 'https://alidocs.dingtalk.com/i/nodes/65ALkBedOKwVBjD05P0NVZq43Nxzop2P', target: '_blank', "data-hottag": 'cn.component.one-search.helpDoc', "data-hottag-name": '\u70B9\u51FB\u8BF4\u660E\u6587\u6863', "data-hottag-ext-params": JSON.stringify({
                        sampling: 1,
                    }), type: 'primary', children: [_jsx(CnIcon, { type: 'dialogue-fill', size: 'medium' }), $i18n.get({ id: 'DescriptionDocument', dm: '说明文档' })] }, 'helpDoc'),
                changeSearchModeBtn,
            ],
    };
}
export default useVersionSwitch;
